import { NotesListNirvanaDataProvider } from '../dataProvider/NotesListNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ, API_TYPE_NIRVANA } from '../../../webcomponents.constants';
import { NotesListGzDataProvider } from '../dataProvider/NotesListGzDataProvider';

export class NotesListDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();

    this.map.set(API_TYPE_NIRVANA, NotesListNirvanaDataProvider);
    this.map.set(API_TYPE_GZ, NotesListGzDataProvider);
  }
}
